//noScroll
class SelectEvent {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
			const Select = jQuery('.form-select');

			$.each(Select, function(i, val) {

				// コンソールに1つずつ出力

				jQuery(val).on('change', function(){
					if (jQuery(val).val() !== ""){
						jQuery(this).removeClass('form-select');
					} else {
						jQuery(this).addClass('form-select');
					}
				});

			});


  }
}
